module.exports = __webpack_public_path__ + "static/img/slider6.02d7ee89.jpg";